<template>
    <div class="aff-container">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('affiliates.title')}}
                <hr>
            </span>
        </h1>
        <!-- AFFILIATES -->
        <div class="row aff-row">
            <p>{{$t('affiliates.introText')}}</p>
        </div>
        <!-- map -->
        <div class="maps-row">
            <img class="map-img" src="../../assets/images/Picture2.png" alt="" v-if="isShow">
            <img class="map-img" src="../../assets/images/asset-3.jpg" alt="" v-if="!isShow">
        </div>
        <div class="full-row">
            <img src="../../assets/images/Layer 2.png" alt="">
        </div>
        <div class="row">
            <ul class="pro-list">
                <li v-for="item in proList[$i18n.locale]" :key="item">
                    <span>
                        <img :src="item.imgUrl" alt="">
                    </span>
                    <h1>{{item.title}}</h1>
                    <p>{{item.text}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isShow:document.body.clientWidth>=768?true:false,
                proList:{
                    EN:[
                        {
                            imgUrl:require('../../assets/images/Laptop.png'),
                            title:"Rugged Computing Solutions",
                            text:"Getac Rugged Solution Business Unit (RSBU) develops Getac rugged notebooks, tablets, and handheld devices sold across 80 countries worldwide. Getac RSBU is proudly the leading international supplier of rugged computers.Getac also offers customization services and integrated solutions to help customers overcome their unique challenges."
                        },
                        {
                            imgUrl:require('../../assets/images/MPT_img.png'),
                            title:"Mechanical Solutions",
                            text:"MPT Solution is renowned for its mature Rapid Heat Cycle Molding (MHCM) and double injection. We at MPT Solution combine advanced surface processing technologies to provide high-quality, high-yield, and aesthetic composite mechanical parts."
                        },{
                            imgUrl:require('../../assets/images/Car.png'),
                            title:"Automotive Parts",
                            text:"Getac Automotive BG specializes in die-casting aluminum-magnesium alloys, tooling and CNC machining. Since its establishment in 2006, Getac Automotive BG has established close business relationships with many well-known automotive suppliers. In 2016, Getac Automotive BG shipped more than 140 million seat belt spools and spools annually."
                        },{
                            imgUrl:require('../../assets/images/Plane.png'),
                            title:"Aerospace Fasteners",
                            text:"Getac's primary affiliate, National Aerospace Fasteners Corporation (NAFCO; TSE:3004), is an international aerospace fastener manufacturer. NAFCO has achieved AS9100 Aerospace Quality System Certification. NAFCO specializes in producing bolts, nuts and connectors for aircraft engines and aircraft using rigid, high temperature metals. In addition to standard parts, customized products can also be provided according to the special requirements of customers."
                        }
                    ],
                    CN:[
                        {
                            imgUrl:require('../../assets/images/Laptop.png'),
                            title:"强固型解决方案",
                            text:"Getac Rugged Solution Business Unit (RSBU) 开发出 Getac 强固型笔记本电脑、平板计算机和手持装置，并在世界各地八十多个城市中销售。Getac RSBU 已成为质量一流的强固型计算机的供货商。Getac 也提供客制化服务和整合的解决方案，协助顾客克服其面对的特定问题。"
                        },
                        {
                            imgUrl:require('../../assets/images/MPT_img.png'),
                            title:"机构部件解决方案",
                            text:"汉达精密以成熟的「MHCM」(Rapid Heat Cycle Molding) J急冷急热成型和双射技术而闻名。汉达精密结合先进的表面加工技术，提供高质量、高产率及兼具艺术感的复合材料的机构部件。"
                        },{
                            imgUrl:require('../../assets/images/Car.png'),
                            title:"汽车用机构部件",
                            text:"Getac Automotive BG 专精于压铸铝镁合金、模具与 CNC 加工。Getac Automotive BG 自 2006 年成立起，与众多知名汽车供货商建立了紧密的业务关系。在 2016 年时，Getac Automotive BG 的年度安全带转轴和线轴出货量已超过一亿四千万件。"
                        },{
                            imgUrl:require('../../assets/images/Plane.png'),
                            title:"航天紧固件",
                            text:"Getac 的主要关系企业 National Aerospace Fasteners Corporation (NAFCO; TSE:3004) 是一间国际航天紧固件制造商。NAFCO 已获得 AS9100 系统认证 (AS9100 Aerospace Quality System Certification)。NAFCO 专注于使用耐高温的刚性金属，为航空器引擎和飞机生产螺栓、螺帽和连接器。除标准零件外，亦可依据顾客的特殊要求提供客制化产品。"
                        }
                    ],
                    CHT:[
                        {
                            imgUrl:require('../../assets/images/Laptop.png'),
                            title:"强固型解決方案",
                            text:"Getac Rugged Solution Business Unit (RSBU) 開發出 Getac 強固型筆記型電腦、平板電腦和手持裝置，並在世界各地八十多個城市中銷售。Getac RSBU 已成為品質一流的強固型電腦的供應商。Getac 也提供客製化服務和整合的解決方案，協助顧客克服其面對的特定問題。"
                        },
                        {
                            imgUrl:require('../../assets/images/MPT_img.png'),
                            title:"機構部件解決方案",
                            text:"漢達精密以成熟的「MHCM」(Rapid Heat Cycle Molding) J急冷急熱成型和雙射技術而聞名。漢達精密結合先進的表面加工技術，提供高品質、高產率及兼具藝術感的複合材料的機構部件。"
                        },{
                            imgUrl:require('../../assets/images/Car.png'),
                            title:"汽車用機構部件",
                            text:"Getac Automotive BG 專精於壓鑄鋁鎂合金、模具與 CNC 加工。Getac Automotive BG 自 2006 年成立起，與眾多知名汽車供應商建立了緊密的業務關係。在 2016 年時，Getac Automotive BG 的年度安全帶轉軸和線軸出貨量已超過一億四千萬件。"
                        },{
                            imgUrl:require('../../assets/images/Plane.png'),
                            title:"航天緊固件",
                            text:"Getac 的主要關係企業 National Aerospace Fasteners Corporation (NAFCO; TSE:3004) 是一間國際航天緊固件製造商。NAFCO 已獲得 AS9100 系統認證 (AS9100 Aerospace Quality System Certification)。NAFCO 專注於使用耐高溫的剛性金屬，為航空器引擎和飛機生產螺栓、螺帽和連接器。除標準零件外，亦可依據顧客的特殊要求提供客製化產品。"
                        }
                    ],
                    JP:[
                        {
                            imgUrl:require('../../assets/images/Laptop.png'),
                            title:"強固な対策",
                            text:"Getacの強固な対策ビジネスユニット（RSBU）は、世界各地の80カ国で販売されるGetacの強固なノートPC、タブレット、及びモバイルデバイスを開発しています。 Getac RSBUは、強固なコンピューターに関する世界有数のサプライヤーです。Getacは、お客様独自の課題を克服するために、それぞれのお客様に対応したサービス及び統合対策を提供します。"
                        },
                        {
                            imgUrl:require('../../assets/images/MPT_img.png'),
                            title:"メカニカル対策",
                            text:"マイタックテクノロジー京都株式会社は、成熟した高速ヒートサイクル成形（MHCM）及び二色成形で有名です。 当社は、高品質、高生産性を有し、高品質のコンポジェット材のメカ部品を生産するために先進な表面加工技術を組み合わせています。"
                        },{
                            imgUrl:require('../../assets/images/Car.png'),
                            title:"自動車用メカ部品",
                            text:"Getac Automotive BGは、アルミのダイカスト及びマグネシウム合金、金型並びCNCを専門としています。 Getac Automotive BGは、2006年の創業以来、様々な一流自動車サプライヤーと強固なビジネス関係を構築しました。 Getac Automotive BGのシートベルト用スピンドル・スプールの2016年の年間出荷量は、1億4,000万ピースを超えました。"
                        },{
                            imgUrl:require('../../assets/images/Plane.png'),
                            title:"飛行機用部品",
                            text:"Getacの主要関連会社であるNational Aerospace Fasteners Corporation (NAFCO; TSE:3004)（NAFCO;TSE:3004）は、国際的なエアロスペース産業用ファスナーの製造業者です。 NAFCOは、AAS9100 Aerospace Quality System Certificationを受けています。 航空機エンジンやエアフレーム用のボルト、ナット及びコネクターの生産にフォーカスしたNAFCOの製品は、剛性と耐熱性を持った金属から作られています。 規格部品に加え、製品は、お客様独自のニーズにもカスタマイズできます。"
                        }
                    ]
                }
            }
        },
        mounted(){
            window.onscroll=()=>{
                if(document.documentElement.scrollTop>20){
                    document.querySelector('.maps-row').style.height=0;
                }else{
                    document.querySelector('.maps-row').style.height=document.querySelector(".maps-row img").clientHeight +"px";
                }
            },
            window.onresize = ()=>{
                return (() => {
                    document.querySelector('.maps-row').style.height=document.querySelector(".maps-row img").clientHeight +"px";
                })()
            }
        }
    }
</script>

<style scoped>
    .aff-row{
        margin:2rem auto;
    }
    .maps-row{
        transition: all 1s;
        overflow: hidden;
    }
    .maps-row img{
        max-width: 100%;
        width: 100%;
    }
    .full-row{
        margin:6rem 0;
    }
    .full-row img{
        max-width: 100%;
        height: auto;
    }
    .pro-list li{
        float:left;
        width:25%;
        position: relative;
    }
    .pro-list li::after{
        content: "";
        width:1px;
        height: 48rem;
        position: absolute;
        top: 0;
        right: 0;
        background:#29AAE1;
    }
    .pro-list li:last-child::after{
        width:0;
    }
    .pro-list li span{
        display: block;
        height:10rem;
    }
    .pro-list li span img{
        max-width: 100%;
        width:24%;
        height: auto;
    }
    .pro-list li h1{
        font-size: 2rem;
        font-weight: 600;
        color:#00457A;
        margin:2rem 0;
        padding: 0 4rem;
        height: 4rem;
    }
    .pro-list li p{
        width: 100%;
        padding:0 4rem;
        font-size: 1.4rem;
        text-align: left;
    }
    @media (max-width: 767px){
        .full-row{
            margin:2rem 0;
        }
        .pro-list li{
            width:100%;
            float:initial;
        }
        .pro-list li span{
            height: auto;
        }
        .pro-list li h1{
            font-size: 1rem;
            margin:1rem auto;
            height: auto;
            margin-top: 2rem;
            padding:0;
        }
        .pro-list li p{
            font-size: 0.7rem;
            padding:0 1rem;
            margin-bottom: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Company/Affiliates.vue